import { AbstractFormatter } from '../Formatter';
import { TypedValue } from '../DataPrimitive';
import { DataPoint } from '../DataPoint';
import EncodingExecutor from '../EncodingExecutor';

/**
 * Math function to subtract.
 *
 * ```js
 * <SampleViz
 *     context={{
 *         divisor: '> majorValue | subtract(trendValue)'
 *     }}
 * />
 * ```
 */
export class Subtract extends AbstractFormatter<'number', 'number'> {
    private valToSubtract: number;

    constructor(valToSubtract: any) {
        super();
        this.valToSubtract = EncodingExecutor.rawTree(valToSubtract);
    }

    protected formatTypedValue(p: DataPoint<'number'>): TypedValue<'number'> {
        const { value } = p.getValue();
        const difference = this.valToSubtract !== 0 && value - this.valToSubtract;
        return { value: difference, type: 'number' };
    }
}
